import { DaoModel } from '@dynameat/models';

export class User extends DaoModel {
  constructor(username, firstName, email, isActive) {
    super();
    this.username = username;
    this.firstName = firstName;
    this.email = email;
    this.isActive = isActive || false;
  }

  static toInstance(props = {}) {
    return new User(props.username, props.first_name, props.email, props.is_active);
  }

  serialize() {
    return {
      username: this.username,
      first_name: this.firstName,
      email: this.email,
      is_active: this.isActive,
    };
  }
}
